module.exports = require("@swa-ui/dotcom/src/placements/DestinationByOriginPlacement/DestinationByOriginCard/DestinationByOriginCard.module.scss");